import $ from 'jquery'
import Swiper from 'swiper/bundle'

var swiper = new Swiper(".story-block__slider", {
    slidesPerView: 4,
    spaceBetween: 30,
    navigation: {
        nextEl: ".story-block__button-next",
        prevEl: ".story-block__button-prev",
    },
    breakpoints: {
        375: {
            slidesPerView: 1.2,
        },
        768: {
            slidesPerView: 2.5,
        },
        992: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 4,
        },
    },
});